import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';

import { Behavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import { PgFlagNotificationService } from '../../../../pg-notification/pg-flag-notification/pg-flag-notification.service';

export enum ResumeTypeEnum {
  Session = 0,
  Login = 1,
}

// CONSTs Copied from ecom.
const loginResumeInvalidSsn = 2;
const loginResumeApplicationDenied = 4;

@Injectable()
export class OtpVerifySsn implements Behavior {
  constructor(public http: HttpClient) {}

  async execute(
    args: {
      resumeUserBaseUrl: string;
      ssnFormControlName: string;
      errorTitle: string;
      errorMessage: string;
      errorAction: string;
    },
    context: BehaviorContext
  ): Promise<any> {
    const ecomSessionId = context.get('sessionId');
    const template = context.get('template');
    const otpAuthenticationId = context.get('otpAuthenticationId');
    const ssnControl = context.formGroup.get(args.ssnFormControlName);

    //   let url = `${baseUrl}/session/${sessionId}/resume`;
    // if (authId && ssn) {
    //   url += `?authId=${authId.replace(
    //     '+',
    //     '%2b'
    //   )}&lastFourSocial=${ssn}&resumeType=${ResumeTypeEnum.Login}`;
    // } else {
    //   url += `?resumeType=${ResumeTypeEnum.Session}`;
    // }

    // TODO: this evaluation of the HTTP response is hard coded to ecom's
    // values; this should be made configurable for forge's values.
    let resumableState: any;
    const result = await this.http
      .get<any>('url')
      .pipe(
        map(data => {
          resumableState = {
            ...resumableState,
            pageKey: data.resumeData.pageKey,
            sessionId: data.sessionId,
          };
          if (
            resumableState.pageKey === 'denied' &&
            data.leaseStatus.toLowerCase() === 'approved'
          ) {
            resumableState.pageKey = 'results';
          }
          return data;
        })
      )
      .toPromise();

    if (result.resumable) {
      template.goToPage(resumableState.pageKey);
    } else {
      switch (parseInt(result.LoginStatusReason, 10)) {
        case loginResumeInvalidSsn:
          break;
        case loginResumeApplicationDenied:
          // TODO: show alert as well.
          break;
      }
    }
  }
}

@Injectable()
export class TestOtpVerifySsn implements Behavior {
  constructor(public flagService: PgFlagNotificationService) {}
  async execute(
    args: { [key: string]: any },
    context: BehaviorContext
  ): Promise<any> {
    return new Promise(res => {
      setTimeout(() => {}, 1500);
    });
  }
}
